export enum CELL_TYPE {
    POPUP = 'POPUP',
    GAMES = 'GAMES',
    BUTTON = 'BUTTON',
    DEFAULT = 'DEFAULT',
    PROGRESS_BAR = 'PROGRESS_BAR'
}

export interface IAccordionRowDefault {
    id: number;
    key: string;
    value: string;
    type: CELL_TYPE.DEFAULT;
}

export interface IAccordionRowPopup {
    id: number;
    key: string;
    type: CELL_TYPE.POPUP;
    value?: {
        popupWcId: string;
        popupTitle: string;
    };
}

export interface IAccordionRowButton {
    id: number;
    key: string;
    type: CELL_TYPE.BUTTON;
    value?: {
        bonusName: string;
        bonusInstanceCode: string;
    };
}

export interface IAccordionRowGames {
    id: number;
    key?: string;
    type: CELL_TYPE.GAMES;
    value: {
        playableGameTypes?: string[];
        isLoading?: boolean;
        error?: string;
    } | null;
}

export interface IAccordionRowProgressBar {
    id: number;
    key: string;
    type: CELL_TYPE.PROGRESS_BAR;
    value: string;
}

export type IAccordionRow = IAccordionRowDefault
    | IAccordionRowPopup
    | IAccordionRowButton
    | IAccordionRowProgressBar
    | IAccordionRowGames;
